import * as _ from 'lodash';

import { CriteriaContext } from '../feature.service';
import { extractBrandIdFromUrl } from '../../../b2b-order/retailer-platform/order/shop/no-access-product/no-access-product.component';
import { insightsEnabledForManufacturer } from 'app/insights/config/enabled-organizations';

const FASHION_CLOUD_MANUFACTURER_ORGANIZATION_ID = '56f06aa57136bd4a7d42c521';

export const criteria = [
    {
        id: 'isEnabledForDevUsers',
        check: (context: CriteriaContext) => {
            const enabledEmails = [
                'dev+admin@fashion.cloud',
                'dev+retailer@fashion.cloud',
                'dev+retailer2@fashion.cloud',
                'dev+retailer+opc@fashion.cloud',
                'dev+manufacturer@fashion.cloud',
                'agon.hyseni+qa@fashion.cloud',
                'studioanneloes@fashion.cloud'
            ];
            if (context.user.email) {
                return _.includes(enabledEmails, context.user.email);
            }

            const enabledOrganizationIds = [
                '594286a9be800f26792ddb50',
                '5942862d20eca8b9571587d8',
                '56f06aa57136bd4a7d42c521'
            ];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForOrderDevUsers',
        check: (context: CriteriaContext) => {
            const enabledEmails = ['dev+retailer+opc@fashion.cloud'];
            return _.includes(enabledEmails, context.user.email);
        }
    },
    {
        id: 'isEnabledForAllUsers',
        check: () => true
    },
    {
        id: 'isEnabledForAmsDevUsers',
        check: (context: CriteriaContext) => {
            const enabledEmails = [
                'orderwriter@studioanneloes.nl',
                'sander@arthurenwillemijn.nl',
                'studioanneloes@fashion.cloud'
            ];
            return _.includes(enabledEmails, context.user.email);
        }
    },
    {
        id: 'isEnabledForContentDevUsers',
        check: (context: CriteriaContext) => {
            const enabledEmails = [
                'dev+admin@fashion.cloud',
                'dev+retailer@fashion.cloud',
                'dev+manufacturer@fashion.cloud',
                'dev+retailer.marketingmanager@fashion.cloud',
                'dev+retailer.buyer@fashion.cloud',
                'manufacturer@fashion.cloud',
                'dushan.silva+mm@fashion.cloud',
                'dev+manufacturer+search@fashion.cloud',
                'dushan.silva+sales.agent@fashion.cloud'
            ];
            return _.includes(enabledEmails, context.user.email);
        }
    },
    {
        id: 'needsVatInConnectModal',
        check: (context: CriteriaContext & { brandId: string }) => {
            const enabledBrands = ['634ea9d55884360011810173', '56c185b4dda95ba659ba1f9a'];

            return _.includes(enabledBrands, context.extraParams.brandId);
        }
    },
    {
        id: 'isEnabledForCavani',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = ['605b515f0f01b80010e42b35'];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForAngels',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = ['5faa59c68e8ef90010e288bf'];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForStudioAnneloes',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = ['5ce6826aaa7bb50012db572a'];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForGstar',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = ['5e4d05f7ba80370011c93f95'];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForFunkyBuddha',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = ['662241d295e7f203defd70ab'];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForDevAndSRUsers',
        check: (context: CriteriaContext) => {
            const enabledEmails = [
                'dev+admin@fashion.cloud',
                'dev+retailer@fashion.cloud',
                'dev+retailer2@fashion.cloud',
                'dev+retailer+opc@fashion.cloud',
                'dev+manufacturer@fashion.cloud',
                'studioanneloes@fashion.cloud',
                'sander@arthurenwillemijn.nl'
            ];
            if (context.user.email) {
                return _.includes(enabledEmails, context.user.email);
            }

            const enabledOrganizationIds = [
                '594286a9be800f26792ddb50',
                '5942862d20eca8b9571587d8',
                '56f06aa57136bd4a7d42c521'
            ];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    {
        id: 'isEnabledForVanBommelShop',
        check: (context: CriteriaContext) => {
            const vanBommelBrandsIds = ['5eb8f2a435106e0012ad54db', '5e621d0af15e4b001063ff18'];
            const type = context.user.organization.type;
            if (type === 'retailer') {
                return _.includes(vanBommelBrandsIds, extractBrandIdFromUrl(context.location.path));
            } else if (type === 'manufacturer') {
                return _.includes(vanBommelBrandsIds, extractBrandIdFromUrlForManufacturer(context.location.path));
            }
            return false;
        }
    },
    {
        id: 'isSelectivelyDisabledForB2BBrands',
        check: (context: CriteriaContext) => {
            const brandIds = {
                ETERNA: '56c427d0f80714af5fbc55cb'
            };

            const type = context.user.organization.type;

            if (type === 'retailer') {
                return !Object.values(brandIds).includes(extractBrandIdFromUrl(context.location.path));
            }

            return true;
        }
    },
    {
        id: 'isSalesRepEnabledForManufacturer',
        check: (context: CriteriaContext) => {
            const enabledOrganizationIds = [
                FASHION_CLOUD_MANUFACTURER_ORGANIZATION_ID,
                '571de6d54947530e0d765e6d',
                '56f06e1d7136bd4a7d42c52a'
            ];
            return _.includes(enabledOrganizationIds, _.toString(context.user.organization._id));
        }
    },
    //TODO: Remove this criteria in favor of canUseInsights config
    {
        id: 'isInsightsEnabledForManufacturer',
        check: (context: CriteriaContext) => {
            return _.includes(insightsEnabledForManufacturer, context.user.organization._id);
        }
    }
];

function extractBrandIdFromUrlForManufacturer(url: string) {
    const brandMatch = url.match(/brand=([^&]+)/);
    return brandMatch ? brandMatch[1] : null;
}
